import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class ReactivePhotosDebugInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('/reactive_photos/')) {
      return next.handle(req);
    }

    const headers: Record<string, string> = {};
    let authLength: number | null = null;
    let authPresent = false;
    req.headers.keys().forEach(key => {
      if (key.toLowerCase() === 'authorization') {
        authPresent = true;
        const value = req.headers.get(key) || '';
        authLength = value.length;
        headers[key] = '[redacted]';
      } else {
        headers[key] = req.headers.get(key) || '';
      }
    });

    console.log('[ReactivePhotos][Request]', {
      method: req.method,
      url: req.url,
      authPresent,
      authLength,
      headerKeys: req.headers.keys(),
      headers,
      body: this.summarizeBody(req.body)
    });

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          console.log('[ReactivePhotos][Response]', {
            url: req.url,
            status: event.status,
            body: this.summarizeBody(event.body)
          });
        }
      }),
      catchError(err => {
        console.warn('[ReactivePhotos][ResponseError]', {
          url: req.url,
          status: err?.status,
          body: this.summarizeBody(err?.error)
        });
        return throwError(() => err);
      })
    );
  }

  private summarizeBody(body: any): any {
    if (body === null || body === undefined) return body;
    if (typeof body === 'string') {
      return body.length > 300 ? body.slice(0, 300) + '…' : body;
    }
    if (Array.isArray(body)) {
      return { arrayLength: body.length };
    }
    if (typeof body === 'object') {
      const summary: Record<string, any> = {};

      if (body.config) {
        summary['config'] = {
          width: body.config.width,
          height: body.config.height,
          padding: body.config.padding,
          gap: body.config.gap,
          border: body.config.border,
          scaleMode: body.config.scaleMode
        };
      }
      if (Array.isArray(body.photos)) {
        summary['photos'] = { count: body.photos.length };
      }
      if (Array.isArray(body.uids)) {
        summary['uids'] = { count: body.uids.length };
      }
      if (body.hash) {
        summary['hash'] = body.hash;
      }
      if (typeof body.code !== 'undefined') {
        summary['code'] = body.code;
      }
      if (typeof body.message !== 'undefined') {
        summary['message'] = body.message;
      }
      if (body.data) {
        summary['data'] = {
          hasData: true,
          hash: body.data.hash,
          photos: Array.isArray(body.data.photos) ? { count: body.data.photos.length } : undefined,
          compositions: Array.isArray(body.data.compositions) ? { count: body.data.compositions.length } : undefined,
          config: body.data.config ? {
            width: body.data.config.width,
            height: body.data.config.height
          } : undefined
        };
      }

      summary['keys'] = Object.keys(body);
      return summary;
    }

    return body;
  }
}
